import { H1, LayoutBand, Separator } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ResearchHelpContentSkeleton from './components/ResearchHelpContentSkeleton'
import { PersonBandSkeleton } from './ResearchHelpPageSkeleton'

export default function DismissedHintsPageSkeleton(): JSX.Element {
  const [t] = useTranslation()
  return (
    <>
      <PersonBandSkeleton disableColoredBackground />

      <LayoutBand maxWidth="lg" marginY="sm">
        <H1 size="H5">{t('research-help.dismissed-hints.label')}</H1>
        <Separator size="sm" />
        <ResearchHelpContentSkeleton />
      </LayoutBand>
    </>
  )
}
